import { BreadcrumbItemProps } from '@maxtropy/components';

export interface TabsBaseProps {
  onBreacrumbChange?: (routes: BreadcrumbItemProps[]) => void;
  updateFn?: () => void;
}

export function transformSpace(value: string) {
  return value && value.replaceAll(' ', '');
}

export enum PushEmail {
  NO = 0,
  YES = 1,
}

export const EmailPortOptions = [
  {
    label: '465',
    value: 465,
  },
  {
    label: '587',
    value: 587,
  },
];
